import { Component, OnInit, inject } from '@angular/core';
import { IrisLocalStorageService } from '@iris/common/services/utils/iris-local-storage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'language-select',
  templateUrl: './language-select.component.html',
  standalone: false,
})
export class LanguageSelectComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly localStorageService = inject(IrisLocalStorageService);

  userLang = 'en';

  ngOnInit(): void {
    if (['en', 'de'].includes(this.translate.currentLang)) {
      this.userLang = this.translate.currentLang;
    }
  }

  changeLanguage(language: string) {
    if (this.translate.currentLang !== language) {
      this.localStorageService.setItem('defaultAuthLanguage', language);
      document.location.reload();
    }
  }
}
